// extracted by mini-css-extract-plugin
export default {"link":"style_link__zXV9i","centerGrid":"style_centerGrid__5zvkO","img":"style_img__4U8Lm","namegame":"style_namegame__NSjhf","center":"style_center__Zj1+A"};